import { AppEnvironment } from "@/types/common.types.ts";

export const isDemoEnvironment = (): boolean =>
  import.meta.env.VITE_APP_ENVIRONMENT === AppEnvironment.demo;
